/** Public `/help` knowledge base — hidden until content is ready. */
export const HELP_PAGES_ENABLED = false;

export function isLiveBetaEnabled(developmentMode: boolean, configured: string | undefined) {
  return developmentMode || configured?.trim().toLowerCase() === 'true';
}

/** Local development and explicitly flagged deployed-development builds only. */
export const TRACK_RELAY_ENABLED = isLiveBetaEnabled(
  import.meta.env.DEV,
  import.meta.env.VITE_TRACK_RELAY_LIVE_BETA_ENABLED,
);

export const LIVE_BETA_ENABLED = isLiveBetaEnabled(
  import.meta.env.DEV,
  import.meta.env.VITE_TRACK_RELAY_LIVE_BETA_ENABLED,
);
